import { TkvAction, TkvActions } from '../tkvActions';
import { AntragsummerGenerated } from '../actiontypes/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: TkvAction<AntragsummerGenerated>,
): string {
  if (action.type === TkvActions.ANTRAGSNUMMER_GENERATED) {
    return action.payload.antragsnummer;
  }
  return sectionState;
};
